import React from 'react';
import { Field } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem'

const renderTextField = ({input, type = "text", label, placeholder, className, style, InputProps = {}, meta: { touched, error }, disabled, required = false, readOnly = false, multiline = false, rows = 1, data = []}) => (
    <div>
        <TextField
            {...input}
            type={type}
            required={required}
            placeholder={placeholder}
            label={`${label ? label : ''}${touched && error ? error : ''}`}
            className={className}
            style={style}
            error={touched && error}
            disabled={disabled}
            InputProps={{
                readOnly: readOnly,
                ...InputProps
            }}
            inputProps={{
                list: input.name
            }}
            margin="normal"
            multiline={multiline}
            rows={rows}
        />
        <datalist id={input.name}>
            {data.map((item,index) => {
                return <option value={item.value} key={index} />
            })}
        </datalist>
    </div>
    
)
export default (obj) => {
    console.info(obj)
    return <Field component={renderTextField} {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/datalist.js